import { FC } from "react";
import { IMiniBoxElementProps } from "./types";

const MiniBoxElement: FC<IMiniBoxElementProps> = ({ children, selected }) => {
  return (
    <div
      className={`flex items-center justify-center min-h-8 border border-greyBorder ${
        selected ? "border-l-blueDark border-l-4 bg-blueHover" : "bg-white"
      } rounded-md transition-all duration-450 mr-1 min-w-14 cursor-pointer hover:bg-blueHover hover:shadow-md px-2`}
    >
      {children}
    </div>
  );
};

export default MiniBoxElement;
